export default __webpack_public_path__ + "static/media/pdf.01d76698.svg";